import { headerBlock, footerBlock, buildEmpleadorBlock } from '../blocks/header'
import { buildRankingSection } from '../blocks/ranking'
import { buildPersonasRows } from '../blocks/tablas'

export const buildPage2 = ({
  today,
  periodoDesde,
  periodoHasta,
  totalPages,
  empleador,
  reportData,
  topRankingSiniestros,
  topDenunciantes,
}) => `
  <div class="page page-break">
    ${headerBlock(today, periodoDesde, periodoHasta)}
    ${buildEmpleadorBlock(empleador, reportData)}

    <!-- RANKING CIE-10 -->
    ${buildRankingSection(topRankingSiniestros)}

    <!-- TOP DENUNCIANTES -->
    <div class="table-section">
      <div class="section-title">TOTAL HISTÓRICO DE PERSONAS TRABAJADORAS CON MÁS DENUNCIAS</div>
      <table class="main">
        <tr>
          <th>CUIL</th>
          <th style="width:125.31px;">Apellido y nombre</th>
          <th class="r">Denuncias</th>
          <th class="r">A.T</th>
          <th class="r">I.T</th>
          <th class="r">E.P</th>
          <th class="r">Juicios</th>
          <th class="r">Autodenuncias</th>
          <th>Estado activo</th>
        </tr>
        ${buildPersonasRows(topDenunciantes, 'No se registran denunciantes para el período seleccionado.')}
      </table>
    </div>

    ${footerBlock(2, totalPages)}
  </div>`
